(() => {

  var HelperApp = (() => {
    var addNewBlockToKachingBundleSection = () => {
      function waitForBundleSection(callback) {
        // First check if the element already exists
        const existingElement = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');
        if (existingElement) {
          callback(existingElement);
          return;
        }
    
        // If DOM is not ready, wait for it
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            pollForElement(callback);
          });
        } else {
          pollForElement(callback);
        }
      }
    
      function pollForElement(callback) {
        const checkInterval = setInterval(() => {
          const element = document.querySelector('.kaching-bundles__block.kaching-bundles__block--loaded');
          if (element) {
            clearInterval(checkInterval);
            callback(element);
          }
        }, 100); // Check every 100ms
    
        // Stop polling after 30 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          console.warn('Kaching bundle section not found within 30 seconds');
        }, 30000);
      }
    
      // Actually call the function with a callback
      waitForBundleSection((section) => {
        console.log('here is waitforbundle section function');
        if (!document.body.classList.contains('page-shapping-c-vibe-3-0')) return;
        if (section.querySelector('.bundle--shipping-text')) {
          console.log('Shipping text already exists, skipping...');
          return;
        }
        
        // Find the title element
        const titleElement = section.querySelector('.kaching-bundles__block-title');
        
        const textBlock = `
          <div class="bundle--shipping-text">
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                <g clip-path="url(#clip0_1051_9097)">
                  <path d="M8.49992 14.7913C12.1818 14.7913 15.1666 11.8066 15.1666 8.12467C15.1666 4.44278 12.1818 1.45801 8.49992 1.45801C4.81802 1.45801 1.83325 4.44278 1.83325 8.12467C1.83325 11.8066 4.81802 14.7913 8.49992 14.7913Z" stroke="#007A4D" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.5 8.12533L7.83333 9.45866L10.5 6.79199" stroke="#007A4D" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_1051_9097">
                    <rect width="16" height="16" fill="white" transform="translate(0.5 0.125)"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span class="text">Incl. free shipping to the US & worldwide</span>
          </div>
        `;
        
        if (titleElement) {
          // Insert your HTML content right after the title element
          titleElement.insertAdjacentHTML('afterend', textBlock);
          console.log('Shipping text added after title element');
        } else {
          console.warn('kaching-bundles__block-title not found, appending to end');
          // Fallback: add to the end of the section
          section.insertAdjacentHTML('beforeend', textBlock);
          console.log('Shipping text added to end of section');
        }
      });
    };

    var addItemToCart = async (variant_id, quantity = 1) => {
      const formData = new URLSearchParams();
      formData.append('id', variant_id);
      formData.append('quantity', quantity);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));
          // document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
          //   bubbles: true,
          //   detail: {
          //     items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          //     cart: cartContent
          //   }
          // }));
  
          // document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          //   bubbles: true,
          //   detail: {
          //     baseEvent: "variant:add",
          //     cart: cartContent
          //   }
          // }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };
  
    return {
      addItemToCart: addItemToCart,
      addNewBlockToKachingBundleSection: addNewBlockToKachingBundleSection
    };
  })();
  

  var PDPSizeFinderApp = (() => {
    var selectBlock = (element) => {
      if (!element || !element.closest('product-gallery')) return;
      const container = element.closest('product-gallery');
      let index = 0;
      element.querySelectorAll('.product-gallery__media').forEach((media, i) => {
        if (media.classList.contains('is-selected')) {
          index = i;
        }
      });
      container.querySelectorAll(`[js-pdp-size-finder-wrapper] [data-index]`).forEach(block => {
        if (block.classList.contains('active')) {
          block.classList.remove('active');
        }
        if (block.getAttribute('data-index') === String(index)) {
          block.classList.add('active');
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('product-gallery media-carousel').forEach(carousel => {
        carousel.addEventListener('scrollend', (e) => {
          selectBlock(carousel);
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var ShippingProtectApp = (() => {
    let shippingProtectLineId = null;
    var addShippingProtect = async (variant_id, element) => {
      if (!element) return;
      element.classList.add('loading');
      element.classList.add('active');
      const formData = new URLSearchParams();
      formData.append('id', variant_id);
      formData.append('quantity', 1);
      formData.append('properties[_is_shipping_protect]', true);
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };
    var removeShippingProduct = async (element) => {
      if (!shippingProtectLineId) return;
      if (!element) return;
      element.classList.add('loading');
      element.classList.remove('active');
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: shippingProtectLineId,
          quantity: 0
        })
      })).json();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
    var checkAddedShippingProduct = async (variant_id) => {
      let flag = false;
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.items.forEach(item => {
        if (String(item.id) === String(variant_id)) {
          flag = true;
          shippingProtectLineId = item.key;
        }
      });
      return flag;
    }
    var trigger = async (element) => {
      if (!element) return;
      if (element.classList.contains('loading')) return;
      const flag = await checkAddedShippingProduct(element.getAttribute('data-variant-id'));
      if (!flag) {
        addShippingProtect(element.getAttribute('data-variant-id'), element);
      } else {
        removeShippingProduct(element);
      }
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.hasAttribute('js-shipping-protect-trigger')) {
          element = event.target;
        }
        if (event.target.closest('[js-shipping-protect-trigger]')) {
          element = event.target.closest('[js-shipping-protect-trigger]');
        }
        if (element) {
          trigger(element);
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var CartTimerApp = (() => {
    const TIMER_KEY = "reservation_timer_end";
    const RESERVATION_DURATION_MINUTES = 10;
  
    var runCountdown = () => {
      setInterval(() => {
        let endTime = localStorage.getItem(TIMER_KEY);
  
        if (!endTime) {
          return;
        }

        endTime = parseInt(endTime, 10);

        const timerElement = document.querySelector("[js-cart-drawer-timer]");
        if (!timerElement) return;
        const now = Date.now();
        const remaining = endTime - now;
  
        if (remaining <= 0) {
          timerElement.style.display = 'none';
          localStorage.removeItem(TIMER_KEY);
          return;
        }

        timerElement.style.display = 'flex';
  
        const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
  
        if (timerElement.querySelector('[data-template]')) {
          timerElement.querySelector('[data-template]').innerText = String(timerElement.querySelector('[data-template]').getAttribute('data-template')).replace('((value))', `${pad(minutes)}:${pad(seconds)}`);
        }
      }, 3);
    }
  
    var pad = (n) => {
      return n < 10 ? '0' + n : n;
    }

    var initialize = () => {
      let endTime = localStorage.getItem(TIMER_KEY);

      if (!endTime) {
        const now = new Date();
        now.setMinutes(now.getMinutes() + RESERVATION_DURATION_MINUTES);
        endTime = now.getTime();
        localStorage.setItem(TIMER_KEY, endTime);
      }

      runCountdown();
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellProductApp = (() => {
    function arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }

    var addUpsellProduct = async (container) => {
      if (!container || !container.querySelector('script')) return;
      const productInfo = JSON.parse(container.querySelector('script').innerHTML);
      if (!productInfo.variants) return;
      const valueList = [];
      container.querySelectorAll('.variant-option').forEach(element => {
        if (element.querySelector('.active[data-value]')) {
          valueList.push(element.querySelector('.active[data-value]').getAttribute('data-value'))
        } else if (element.querySelector('select')) {
          valueList.push(element.querySelector('select').value);
        }
      });
      let variantId = null;
      productInfo.variants.forEach(variant => {
        if (arraysEqual(variant.options, valueList)) {
          variantId = variant.id;
        }
      });
      if (variantId === null) return;
      container.classList.add('loading');
      const formData = new URLSearchParams();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('properties[_upsell_added]', "true");
  
      try {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
  
        const responseJson = await response.json();
  
        if (response.ok) {
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cartContent["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent("cart:refresh"));

          container.classList.add('success');
          container.classList.remove('loading');
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"] || "Unknown error"
            }
          }));
  
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
      } catch (error) {
        console.error("Add to cart failed:", error);
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Network error"
          }
        }));
  
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    }
    var colorChanged = (element, container) => {
      if (!element || !element.closest('.variant-color-option') || !container) return;
      element.closest('.variant-color-option').querySelectorAll('[data-value]').forEach(valueElement => {
        valueElement.classList.remove('active');
      });
      element.classList.add('active');
      const variantId = element.getAttribute('data-variant-id');
      if (variantId !== '') {
        container.querySelectorAll('.image-wrapper img').forEach(image => {
          if (image.getAttribute('data-variant-id') === variantId) {
            image.classList.add('active');
          } else {
            image.classList.remove('active');
          }
        });
      }
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        let element = null;
        if (event.target.closest('[js-cart-drawer-upsell-atc]')) {
          element = event.target.closest('[js-cart-drawer-upsell-atc]');
        }
        if (element && element.closest('[js-container]') && !element.closest('[js-container]').classList.contains('loading')) {
          addUpsellProduct(element.closest('[js-container]'));
        }
        if (event.target.closest('[data-value]') && event.target.closest('.variant-color-option')) {
          element = event.target.closest('[data-value]');
          colorChanged(element, element.closest('[js-container]'));
        }
      });
    }
    return {
      init: initialize
    }
  })();

  var TabsContainerApp = (() => {
    var open = (container, index) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        element.classList.remove('active');
        if (element.getAttribute('data-index') === index) {
          element.classList.add('active');
        }
      });
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(container, element.getAttribute('data-index'));
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tabs-container]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();


  var PDPBundlePickerApp = (() => {
    var addBundleToCart = async (container) => {
      if (!container) return;
      
      const current_bundle_option_index = parseInt(container.getAttribute('data-selected-bundle-option'));
      let variant_id_list = [];
      
      // Collect variant IDs based on selected bundle option
      container.querySelectorAll('[js-bundle-variant-picker][data-variant-id]').forEach((element, index) => {
        if (index < current_bundle_option_index) {
          variant_id_list.push(element.getAttribute('data-variant-id'));
        }
      });
    
      if (variant_id_list.length === 0) {
        console.warn('No variants selected for bundle');
        return;
      }
    
      // Disable submit buttons during processing
      const submitButtons = container.querySelectorAll('[js-submit]');
      submitButtons.forEach((button) => {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-busy', 'true');
      });
    
      try {
        // Prepare sections to bundle (similar to theme.js product form logic)
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { 
          bubbles: true, 
          detail: { sections: sectionsToBundle } 
        }));
    
        // Prepare items for bulk add to cart
        const items = variant_id_list.map(variant_id => ({
          id: variant_id,
          quantity: 1
        }));
    
        // Prepare the request body
        const requestBody = {
          items: items
        };
    
        // Add sections if available
        if (sectionsToBundle.length > 0) {
          requestBody.sections = sectionsToBundle.join(',');
          requestBody.sections_url = `${Shopify.routes.root}variants/${variant_id_list[0]}`;
        }
    
        // Add all variants to cart at once
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(requestBody)
        });
    
        if (!response.ok) {
          const errorJson = await response.json();
          throw new Error(errorJson.description || 'Failed to add bundle to cart');
        }
    
        const responseJson = await response.json();
        
        // Get updated cart content
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        
        // Add sections from response if available
        if (responseJson.sections) {
          cartContent["sections"] = responseJson["sections"];
        }
    
        // Dispatch variant:add event (similar to theme.js)
        container.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson], // Handle both single and multiple item responses
            cart: cartContent,
            blockCartDrawerOpening: false // Allow cart drawer to open
          }
        }));
    
        // Dispatch cart:change event (similar to theme.js)
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
    
      } catch (error) {
        console.error("Bundle add to cart failed:", error);
    
        // Dispatch error event
        container.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: error.message || "Failed to add bundle to cart"
          }
        }));
    
        // Refresh cart on error
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        
      } finally {
        // Re-enable submit buttons
        submitButtons.forEach((button) => {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
        });
      }
    }
    
    var selectBundleOption = (container, option_index) => {
      if (!container) return;
      container.setAttribute('data-selected-bundle-option', option_index);
      container.querySelectorAll('[data-bundle-option]').forEach(element => {
        if (element.getAttribute('data-bundle-option') === option_index) element.classList.add('active');
        else element.classList.remove('active');
      });
      
      // Force reinitialize all variant pickers with different default colors
      // Use requestAnimationFrame to ensure DOM updates are complete
      requestAnimationFrame(() => {
        container.querySelectorAll('[js-bundle-variant-picker]').forEach(element => {
          BundleVariantPickerApp.initializeDefaultVariant(element);
        });
      });
    }
    
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[data-bundle-option]').forEach(element => {
        element.addEventListener('click', () => {
          selectBundleOption(container, element.getAttribute('data-bundle-option'));
        });
      });
      container.querySelectorAll('[js-submit]').forEach(element => {
        element.addEventListener('click', () => {
          addBundleToCart(container);
        });
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-bundle-picker]').forEach(container => {
        initEachContainer(container);
      });
    }
    
    return {
      init: initialize
    }
  })();


  var BundleVariantPickerApp = (() => {
    var productData = {};
    
    var getCurrentOptions = (container) => {
      const options = {};
      container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, index) => {
        const selectedOption = wrapper.querySelector('[js-option].selected');
        if (selectedOption) {
          options[`option${index + 1}`] = selectedOption.getAttribute('js-option');
        }
      });
      return options;
    };
  
    var findVariantByOptions = (productId, options) => {
      const product = productData[productId];
      if (!product || !product.variants) return null;
  
      return product.variants.find(variant => {
        return variant.option1 === options.option1 &&
               variant.option2 === options.option2 &&
               variant.option3 === options.option3;
      });
    };
  
    var isOptionAvailable = (productId, optionIndex, optionValue, currentOptions) => {
      const product = productData[productId];
      if (!product || !product.variants) return false;
  
      const testOptions = { ...currentOptions };
      testOptions[`option${optionIndex}`] = optionValue;
  
      return product.variants.some(variant => {
        const matches = Object.keys(testOptions).every(key => {
          const optionNum = key.replace('option', '');
          return variant[`option${optionNum}`] === testOptions[key] || !testOptions[key];
        });
        return matches && variant.available;
      });
    };
  
    var updateOptionAvailability = (container) => {
      const productJson = container.querySelector('script[data-product-json]');
      if (!productJson) return;
  
      try {
        const product = JSON.parse(productJson.textContent);
        const productId = product.id;
        productData[productId] = product;
  
        const currentOptions = getCurrentOptions(container);
  
        container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, wrapperIndex) => {
          const optionIndex = wrapperIndex + 1;
          
          wrapper.querySelectorAll('[js-option]').forEach(optionElement => {
            const optionValue = optionElement.getAttribute('js-option');
            const isAvailable = isOptionAvailable(productId, optionIndex, optionValue, currentOptions);
            
            if (isAvailable) {
              optionElement.classList.remove('disabled');
            } else {
              optionElement.classList.add('disabled');
            }
          });
        });
  
        const currentVariant = findVariantByOptions(productId, currentOptions);
        if (currentVariant) {
          const pdpBundlePicker = container.closest('[js-pdp-bundle-picker]');
          if (pdpBundlePicker) {
            const selectedBundleOption = pdpBundlePicker.getAttribute('data-selected-bundle-option');
            const containerIndex = container.getAttribute('js-bundle-variant-picker');
            
            // Try multiple ways to find the color option
            let selectedColorOption = container.querySelector('[js-option].color-option.selected'); // Original way
            
            if (!selectedColorOption) {
              // Fallback: find selected option in first wrapper (usually color)
              selectedColorOption = container.querySelector('[js-option-wrapper]:first-child [js-option].selected');
            }
            
            if (!selectedColorOption) {
              // Another fallback: find any selected option
              selectedColorOption = container.querySelector('[js-option].selected');
            }
            
            if (selectedColorOption) {
              const selectedColor = selectedColorOption.getAttribute('js-option');
              
              pdpBundlePicker.querySelectorAll(`[data-bundle-option="${selectedBundleOption}"] .image-wrapper img[data-index="${containerIndex}"]`).forEach(image => {
                if (image.getAttribute('data-color-value') == selectedColor) {
                  image.classList.add('active');
                } else {
                  image.classList.remove('active');
                }
              });
            }
          }
          
          container.setAttribute('data-variant-id', currentVariant.id);
          container.dispatchEvent(new CustomEvent('bundle:variant:change', {
            detail: {
              variant: currentVariant,
              product: product
            }
          }));
        }
  
      } catch (error) {
        console.error('Error parsing product JSON:', error);
      }
    };
  
    var changeVariant = (container, option) => {
      if (!container || !option) return;
      
      if (option.classList.contains('disabled')) {
        return;
      }
  
      const optionWrapper = option.closest('[js-option-wrapper]');
      if (!optionWrapper) return;
  
      optionWrapper.querySelectorAll('[js-option]').forEach(element => {
        element.classList.remove('selected');
      });
      option.classList.add('selected');
  
      const currentOptionLabel = optionWrapper.querySelector('[js-current-option]');
      if (currentOptionLabel) {
        currentOptionLabel.innerText = option.getAttribute('js-option');
      }
  
      updateOptionAvailability(container);
    };
  
    var initializeDefaultVariant = (container) => {
      const productJson = container.querySelector('script[data-product-json]');
      if (!productJson) return;
  
      try {
        const product = JSON.parse(productJson.textContent);
        
        // Get the container index to determine which variant to select
        const containerIndex = parseInt(container.getAttribute('js-bundle-variant-picker')) || 1;
        
        // Get all available variants
        const availableVariants = product.variants.filter(variant => variant.available);
        
        if (availableVariants.length === 0) return;
        
        // Find color option (assuming it's typically option1, but let's be flexible)
        let colorOptionIndex = 1; // Default to option1
        const colorLabels = ['color', 'colour', 'farbe', 'couleur']; // Add more languages as needed
        
        product.options.forEach((option, index) => {
          if (colorLabels.includes(option.toLowerCase())) {
            colorOptionIndex = index + 1;
          }
        });
        
        // Get unique color values from available variants
        const availableColors = [...new Set(availableVariants.map(variant => 
          variant[`option${colorOptionIndex}`]
        ))].filter(color => color); // Filter out null/undefined values
        
        let selectedVariant;
        
        // Try to select a different color for each container
        if (availableColors.length >= containerIndex) {
          // If we have enough colors, select the nth color for the nth container
          const targetColor = availableColors[containerIndex - 1];
          selectedVariant = availableVariants.find(variant => 
            variant[`option${colorOptionIndex}`] === targetColor
          );
        } else {
          // If not enough colors, cycle through available colors
          const colorIndex = (containerIndex - 1) % availableColors.length;
          const targetColor = availableColors[colorIndex];
          selectedVariant = availableVariants.find(variant => 
            variant[`option${colorOptionIndex}`] === targetColor
          );
        }
        
        // Fallback to first available variant if no color-based selection worked
        if (!selectedVariant) {
          selectedVariant = availableVariants[0];
        }
        
        // Set the selected variant options in the UI
        container.querySelectorAll('[js-option-wrapper]').forEach((wrapper, index) => {
          const optionValue = selectedVariant[`option${index + 1}`];
          const optionElement = wrapper.querySelector(`[js-option][js-option="${optionValue}"]`);
          
          if (optionElement) {
            // Remove selected class from all options in this wrapper
            wrapper.querySelectorAll('[js-option]').forEach(el => el.classList.remove('selected'));
            // Add selected class to the target option
            optionElement.classList.add('selected');
            
            // Update the current option label if it exists
            const currentOptionLabel = wrapper.querySelector('[js-current-option]');
            if (currentOptionLabel) {
              currentOptionLabel.innerText = optionValue;
            }
          }
        });
        
        container.setAttribute('data-variant-id', selectedVariant.id);
  
        // Force update option availability to ensure UI is consistent
        updateOptionAvailability(container);
        
        // Trigger bundle variant change event for any listeners
        container.dispatchEvent(new CustomEvent('bundle:variant:change', {
          detail: {
            variant: selectedVariant,
            product: product
          }
        }));
  
      } catch (error) {
        console.error('Error initializing default variant:', error);
      }
    };
  
    var initEachContainer = (container, nextContainers = []) => {
      if (!container) return;
  
      initializeDefaultVariant(container);
  
      container.querySelectorAll('[js-option-wrapper] [js-option]').forEach(element => {
        element.addEventListener('click', () => {
          changeVariant(container, element);
          nextContainers.forEach(nextContainer => {
            changeVariant(nextContainer, nextContainer.querySelector(`[js-option-wrapper="${element.closest('[js-option-wrapper]').getAttribute('js-option-wrapper')}"] [js-option="${element.getAttribute('js-option')}"]`));
          });
        });
      });
    };
  
    var getNextBundleVariantPickers = (currentContainer) => {
      const nextContainers = [];
      let nextElement = currentContainer.nextElementSibling;
      
      while (nextElement) {
          if (nextElement.matches('[js-bundle-variant-picker]')) {
              nextContainers.push(nextElement);
          }
          nextElement = nextElement.nextElementSibling;
      }
      
      return nextContainers;
    }
  
    var initialize = () => {
      document.querySelectorAll('[js-bundle-variant-picker]').forEach(container => {
        initEachContainer(container, getNextBundleVariantPickers(container));
      });
    };
  
    return {
      init: initialize,
      getCurrentOptions: getCurrentOptions,
      findVariantByOptions: findVariantByOptions,
      initializeDefaultVariant: initializeDefaultVariant
    };
  })();


  var PDPSizePickerApp = (() => {
    var open = (container) => {
      if (!container || !container.querySelector('[js-chart-modal]')) return;
      container.querySelector('[js-chart-modal]').classList.add('open');
    }
    var close = (container) => {
      if (!container || !container.querySelector('[js-chart-modal]')) return;
      container.querySelector('[js-chart-modal]').classList.remove('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-container] [js-chart-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-container]'));
        });
      });
      document.querySelectorAll('[js-container] [js-chart-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          close(element.closest('[js-container]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var CustomSelectElementApp = (() => {
    let observer;
    
    var attachSelectListener = (selectElement) => {
      if (selectElement.hasAttribute('data-listener-attached')) {
        return;
      }
      
      selectElement.addEventListener('change', () => {
        const container = selectElement.closest('[js-custom-select-element]');
        console.log('here is custom element', container);
        const selectedValue = container.querySelector('[js-selected-value]');
        if (selectedValue) {
          selectedValue.innerHTML = selectElement.value;
        }
      });
      
      selectElement.setAttribute('data-listener-attached', 'true');
    };
    
    var processSelectElements = (containerElement = document) => {
      containerElement.querySelectorAll('[js-custom-select-element] select').forEach(selectElement => {
        attachSelectListener(selectElement);
      });
    };
    
    var initializeMutationObserver = () => {
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            
            if (node.hasAttribute && node.hasAttribute('js-custom-select-element')) {
              processSelectElements(node);
            }
            
            if (node.querySelectorAll) {
              processSelectElements(node);
            }
          });
        });
      });
        
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };
    
    var initialize = () => {
      processSelectElements();
      
      initializeMutationObserver();
    };
    
    var destroy = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
        
      document.querySelectorAll('[js-custom-select-element] select[data-listener-attached]').forEach(select => {
        select.removeAttribute('data-listener-attached');
      });
    };
    
    return {
      init: initialize,
      destroy: destroy,
      processNew: processSelectElements
    };
  })();


  var InfoDisplayAfterATCApp = (() => {
    var hide = (element) => {
      if (!element) return;
      element.classList.add('d-none');
    }
    var show = (element) => {
      if (!element) return;
      element.classList.remove('d-none');
    }
    var initialize = () => {
      document.querySelectorAll('[js-display-info-after-atc]').forEach(element => {
        hide(element);
      });
      document.addEventListener('cart:change', (e) => {
        const items = e.detail.cart.items;
        console.log('here is items', items);
        if (document.querySelector('[data-block-type=buy-buttons] input[name=product-id]')) {
          const currentProductId = document.querySelector('[data-block-type=buy-buttons] input[name=product-id]').value;
          let currentItemCount = 0;
          Array.from(items).forEach(item => {
            if (String(item.product_id) === String(currentProductId)) {
              currentItemCount+=item.quantity;
            }
          });
          document.querySelectorAll('[js-display-info-after-atc]').forEach(element => {
            if (element.getAttribute('js-display-info-after-atc') === String(currentItemCount)) {
              show(element);
            } else {
              hide(element);
            }
          });
        }

      });
    }
    return {
      init: initialize
    }
  })();


  var FreeShippingSupportApp = (() => {
    var updateShippingAttribute = async (is_free_shipping) => {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              "__free_shipping": `${is_free_shipping}`
            }
          })
        });
        
        const cart = await response.json();
        console.log('Cart updated:', cart);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
    var run = () => {
      if (
        (
          document.body.hasAttribute('shipping-threshold-ab-test-a') &&
          document.querySelector('.cart-drawer__shipping-threshold-v1.free-shipping')
        ) ||
        (
          document.body.hasAttribute('shipping-threshold-ab-test-b') &&
          document.querySelector('.cart-drawer__shipping-threshold-v2.free-shipping')
        )
      ) {
        updateShippingAttribute(true);
      } else {
        updateShippingAttribute(false);
      }
    }
    var initialize = () => {
      run();
      document.addEventListener('cart:change', (e) => {
        setTimeout(() => {
          run();
        }, 2000);
      });
    }
    return {
      init: initialize
    }
  })();


  var App = (() => {
    var initialize = () => {
      PDPSizeFinderApp.init();
      ShippingProtectApp.init();
      CartTimerApp.init();
      CartDrawerUpsellProductApp.init();
      TabsContainerApp.init();
      PDPBundlePickerApp.init();
      BundleVariantPickerApp.init();
      PDPSizePickerApp.init();
      CustomSelectElementApp.init();
      InfoDisplayAfterATCApp.init();
      FreeShippingSupportApp.init();
      HelperApp.addNewBlockToKachingBundleSection();
      
      // Initialize bundle variant pickers with different default colors immediately
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        const bundlePickers = document.querySelectorAll('[js-pdp-bundle-picker] [js-bundle-variant-picker]');
        if (bundlePickers.length > 0) {
          bundlePickers.forEach(container => {
            BundleVariantPickerApp.initializeDefaultVariant(container);
          });
        } else {
          // If no bundle pickers found immediately, try again after a short delay
          setTimeout(() => {
            document.querySelectorAll('[js-pdp-bundle-picker] [js-bundle-variant-picker]').forEach(container => {
              BundleVariantPickerApp.initializeDefaultVariant(container);
            });
          }, 200);
        }
      });
    }
    
    return {
      init: initialize
    }
  })();
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });


})();